import { getCwUrl } from '../../utils/config';

async function save({ courseId, form }) {
  try {
    const coursewareV1Url = `${getCwUrl()}/api/v1`;

    const response = await fetch(
      `${coursewareV1Url}/course/${courseId}/manual-assignments`,
      {
        method: 'PUT',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Pragma: 'no-cache',
        },
        body: JSON.stringify(form),
      },
    );

    const data = await response.json();

    if (!response.ok) {
      throw data;
    }

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

async function remove({ courseId, assignmentId }) {
  try {
    const coursewareV1Url = `${getCwUrl()}/api/v1`;

    const response = await fetch(
      `${coursewareV1Url}/course/${courseId}/manual-assignments`,
      {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Pragma: 'no-cache',
        },
        body: JSON.stringify({ assignmentId }),
      },
    );

    if (!response.ok) {
      throw response;
    }

    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
}

export default {
  save,
  remove,
};
